import React from 'react';
import { Batiment } from '../../../../shared/types/game';

/** Onglet « Chambres » — port fidèle du prototype (`buildings.js` tabHebergement). */

interface BuildingLitsTabProps {
  building: Batiment;
}

const pad = (n: number) => String(n).padStart(2, '0');

const BuildingLitsTab: React.FC<BuildingLitsTabProps> = ({ building }) => {
  const cap = building.capacite || 0;
  const occ = Math.min(cap, building.postes_occupes || 0);

  return (
    <div className="block">
      <div className="block__h">
        Chambres <span className="mono muted">{occ}/{cap} occupée(s)</span>
      </div>
      <div className="block__b">
        <p className="bsub">
          La capacité d'hébergement suit la capacité personnel du site (<span className="mono">player_building.capacite</span>) :
          {' '}{cap} chambre(s) au niveau {building.niveau ?? 1}.
        </p>
        {cap === 0 ? (
          <div className="empty">Aucune chambre. La capacité augmente avec le niveau et les extensions.</div>
        ) : (
          <div className="cells">
            {Array.from({ length: cap }, (_, i) => (
              <div className={`cell ${i < occ ? 'is-full' : ''}`} key={i}>
                <span className="cell__n mono">{pad(i + 1)}</span>
                <span className="cell__s">{i < occ ? 'occupée' : 'libre'}</span>
              </div>
            ))}
          </div>
        )}
        <p className="bwarn" style={{ marginTop: 8 }}>
          ⚠ L'occupation est indicative : aucune table de patients n'existe encore en base.
        </p>
      </div>
    </div>
  );
};

export default BuildingLitsTab;
